import { useQuery } from "@tanstack/react-query";
import { axios } from "lib/axios";

export const getPublicWoredas = ({ subcityId }) => {
  return axios.get(`/public/addresses/sub_cities/${subcityId}/woredas`);
};

export const usePublicWoredas = ({ subcityId, config } = {}) => {
  return useQuery({
    ...config,
    queryKey: ["public-woredas", subcityId],
    queryFn: () => getPublicWoredas({ subcityId }),
    staleTime: Infinity,
    cacheTime: Infinity,
    refetchOnMount: "always",
    refetchOnWindowFocus: "always",
    refetchOnReconnect: "always"
  });
};
